// src/pages/Roster.js
import React from "react";
import "../App.css";

/* Player images */
import Parx from "../images/Parx.jpg";
import Ryder from "../images/Ryder.jpg";
import Holt from "../images/Holt.jpg";
import Jalen from "../images/Jalen.jpg";
import Jesse from "../images/Jesse.jpg";
import Reid from "../images/Reid.jpg";
import Zach from "../images/Zach.jpg";
import Cade from "../images/Cade.jpg";

/* Coach images */
import CoachWhite from "../images/CoachWhite.jpg";
import CoachKennedy from "../images/CoachKennedy.jpg";
import CoachBarnett from "../images/CoachBarnett.jpg";

/* Banner image (add this image to your images folder if not already there) */
import TeamBanner from "../images/Team2.jpg";

export default function Roster() {
  const players = [
    { number: 1, name: "Parx Daniels", year: "Junior", position: "Guard", image: Parx },
    { number: 2, name: "Reid Dyer", year: "Sophomore", position: "Guard", image: Reid },
    { number: 3, name: "Zach Hash", year: "Sophomore", position: "Guard", image: Zach },
    { number: 4, name: "Ryder Barnett", year: "Junior", position: "Guard", image: Ryder },
    { number: 5, name: "Cade McCullough", year: "Sophomore", position: "Forward", image: Cade },
    { number: 12, name: "Holt Lightner", year: "Senior", position: "Guard", image: Holt },
    { number: 21, name: "Jalen Prado", year: "Senior", position: "Forward", image: Jalen },
    { number: 23, name: "Jesse Robinson", year: "Junior", position: "Forward", image: Jesse },
  ];

  const coaches = [
    { name: "Tyler White", title: "Head Coach", image: CoachWhite },
    { name: "Joe Barnett", title: "Assistant Coach", image: CoachBarnett },
    { name: "Chad Kennedy", title: "Assistant Coach", image: CoachKennedy },
  ];

  return (
    <div className="page roster-page">
      {/* ✅ Team Banner Header */}
      <div className="roster-banner">
        <img src={TeamBanner} alt="Team Banner" className="banner-image" />
        <div className="banner-overlay">
          <h1 className="banner-title">Pottsboro Cardinals</h1>
          <p className="banner-subtitle">2025–2026 Basketball Roster</p>
        </div>
      </div>

      {/* Players Section */}
      <section className="players-section-modern">
        <h2 className="section-title">Players</h2>
        <div className="roster-grid-modern">
          {players.map((p) => (
            <div className="roster-card" key={p.number}>
              <div className="roster-image-wrap">
                {p.image ? (
                  <img src={p.image} alt={p.name} className="roster-photo" />
                ) : (
                  <div className="roster-placeholder">No Photo</div>
                )}
                <div className="player-number">#{p.number}</div>
              </div>
              <div className="roster-info">
                <h3>{p.name}</h3>
                <p>{p.year} • {p.position}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Coaches Section */}
      <section className="coaches-section-modern">
        <h2 className="section-title">Coaching Staff</h2>
        <div className="roster-grid-modern">
          {coaches.map((c, i) => (
            <div className="roster-card" key={i}>
              <div className="roster-image-wrap">
                {c.image ? (
                  <img src={c.image} alt={c.name} className="roster-photo" />
                ) : (
                  <div className="roster-placeholder">Coach</div>
                )}
              </div>
              <div className="roster-info">
                <h3>{c.name}</h3>
                <p>{c.title}</p>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
